import { get } from 'lodash'
import { ROLES } from 'constants/enums'

export default function(activeRole, config) {
  switch (activeRole) {
    case ROLES.LEADER.u:
      return get(config, 'configurationKey.visibleInUiAtAU')

    case ROLES.IF_STAFF_SUPER.u:
      return get(config, 'configurationKey.visibleInUiAtIF')

    case ROLES.NAO_STAFF.u:
      return get(config, 'configurationKey.visibleInUiAtNAO')

    case ROLES.OA.u:
      return get(config, 'configurationKey.visibleInUiAtOA')

    case ROLES.GBT.u:
      return get(config, 'configurationKey.visibleInUiAtRO')

    case ROLES.IF_REGION.u:
      return get(config, 'configurationKey.visibleInUiAtRO')

    default:
  }
}
